var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { staticClass: "p-0", attrs: { fluid: "" } },
    [
      _c("message-view", { attrs: { messages: _vm.messages } }),
      _vm._v(" "),
      _c("div", {
        staticClass: "text-muted text-wrap",
        domProps: { innerHTML: _vm._s(_vm.helpText) },
      }),
      _vm._v(" "),
      _vm.loading === true
        ? _c("div", { staticClass: "text-center my-2" }, [
            _c(
              "div",
              { staticClass: "d-flex justify-content-center" },
              [
                _c("b-spinner"),
                _vm._v(" "),
                _c("div", { staticClass: "p-2" }, [
                  _vm._v(_vm._s(_vm.getString("loading"))),
                ]),
              ],
              1
            ),
          ])
        : _c("validation-observer", {
            ref: "searchRequestObserver",
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({ passes }) {
                    return [
                      _c(
                        "b-form",
                        {
                          staticClass: "mt-3",
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return passes(_vm.onSubmit)
                            },
                            reset: function ($event) {
                              return _vm.$emit("cancel")
                            },
                          },
                        },
                        [
                          _c(
                            "b-form-group",
                            {
                              staticClass: "text-right",
                              attrs: {
                                label: _vm.getString("from"),
                                "label-for": "txtFrom",
                                "label-cols": "2",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: "required|email",
                                  name: _vm.getString("from"),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ valid, errors }) {
                                        return [
                                          _c(
                                            "b-form-input",
                                            _vm._b(
                                              {
                                                attrs: {
                                                  id: "txtFrom",
                                                  type: "email",
                                                  maxlength: "500",
                                                  required: "",
                                                  state: errors[0]
                                                    ? false
                                                    : valid
                                                    ? true
                                                    : null,
                                                  placeholder:
                                                    _vm.getString("fromInput"),
                                                },
                                                model: {
                                                  value: _vm.from,
                                                  callback: function ($$v) {
                                                    _vm.from =
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                  },
                                                  expression: "from",
                                                },
                                              },
                                              "b-form-input",
                                              _vm.$attrs,
                                              false
                                            )
                                          ),
                                          _vm._v(" "),
                                          _vm._l(errors, function (error) {
                                            return _c("p", [
                                              _vm._v(_vm._s(error)),
                                            ])
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              staticClass: "text-left",
                              attrs: {
                                label: _vm.getString("title"),
                                "label-for": "txtTitle",
                                "label-cols": "2",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: "required",
                                  name: _vm.getString("title"),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ valid, errors }) {
                                        return [
                                          _c(
                                            "b-form-input",
                                            _vm._b(
                                              {
                                                attrs: {
                                                  id: "txtTitle",
                                                  type: "text",
                                                  maxlength: "500",
                                                  required: "",
                                                  state: errors[0]
                                                    ? false
                                                    : valid
                                                    ? true
                                                    : null,
                                                  placeholder:
                                                    _vm.getString("titleInput"),
                                                },
                                                model: {
                                                  value: _vm.title,
                                                  callback: function ($$v) {
                                                    _vm.title = $$v
                                                  },
                                                  expression: "title",
                                                },
                                              },
                                              "b-form-input",
                                              _vm.$attrs,
                                              false
                                            )
                                          ),
                                          _vm._v(" "),
                                          _vm._l(errors, function (error) {
                                            return _c("p", [
                                              _vm._v(_vm._s(error)),
                                            ])
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              staticClass: "text-right",
                              attrs: {
                                label: _vm.getString("count"),
                                "label-for": "txtCount",
                                "label-cols": "2",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: "required|numeric|between:1,1000000",
                                  name: _vm.getString("count"),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ valid, errors }) {
                                        return [
                                          _c(
                                            "b-form-input",
                                            _vm._b(
                                              {
                                                attrs: {
                                                  id: "txtCount",
                                                  type: "number",
                                                  min: "1",
                                                  max: "1000000",
                                                  state: errors[0]
                                                    ? false
                                                    : valid
                                                    ? true
                                                    : null,
                                                  placeholder:
                                                    _vm.getString(
                                                      "quantitiesInput"
                                                    ),
                                                },
                                                model: {
                                                  value: _vm.titleCount,
                                                  callback: function ($$v) {
                                                    _vm.titleCount = _vm._n($$v)
                                                  },
                                                  expression: "titleCount",
                                                },
                                              },
                                              "b-form-input",
                                              _vm.$attrs,
                                              false
                                            )
                                          ),
                                          _vm._v(" "),
                                          _vm._l(errors, function (error) {
                                            return _c("p", [
                                              _vm._v(_vm._s(error)),
                                            ])
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              staticClass: "text-right",
                              attrs: {
                                label:
                                  _vm.getString("phone") +
                                  " " +
                                  _vm.getString("optionalField"),
                                "label-for": "txtTelephone",
                                "label-cols": "2",
                              },
                            },
                            [
                              _c("validation-provider", {
                                attrs: {
                                  rules: {
                                    regex:
                                      /^(\(?([\d \-\)\–\+\/\(]+)\)?([ .\-–\/]?)([\d]+))$/,
                                  },
                                  name: _vm.getString("phone"),
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function ({ valid, errors }) {
                                        return [
                                          _c(
                                            "b-form-input",
                                            _vm._b(
                                              {
                                                attrs: {
                                                  id: "txtTelephone",
                                                  type: "tel",
                                                  maxlength: "25",
                                                  state: errors[0]
                                                    ? false
                                                    : valid
                                                    ? true
                                                    : null,
                                                  placeholder:
                                                    _vm.getString(
                                                      "telephoneInput"
                                                    ),
                                                },
                                                model: {
                                                  value: _vm.telephone,
                                                  callback: function ($$v) {
                                                    _vm.telephone =
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                  },
                                                  expression: "telephone",
                                                },
                                              },
                                              "b-form-input",
                                              _vm.$attrs,
                                              false
                                            )
                                          ),
                                          _vm._v(" "),
                                          _vm._l(errors, function (error) {
                                            return _c("p", [
                                              _vm._v(_vm._s(error)),
                                            ])
                                          }),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  true
                                ),
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-form-group",
                            {
                              staticClass: "text-right",
                              attrs: {
                                label:
                                  _vm.getString("comment") +
                                  " " +
                                  _vm.getString("optionalField"),
                                "label-for": "txtComment",
                                "label-cols": "2",
                              },
                            },
                            [
                              _c(
                                "b-form-textarea",
                                _vm._b(
                                  {
                                    attrs: {
                                      id: "txtComment",
                                      type: "text",
                                      maxlength: "1024",
                                      placeholder:
                                        _vm.getString("messageInput"),
                                    },
                                    model: {
                                      value: _vm.comment,
                                      callback: function ($$v) {
                                        _vm.comment =
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                      },
                                      expression: "comment",
                                    },
                                  },
                                  "b-form-textarea",
                                  _vm.$attrs,
                                  false
                                )
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "offset-2 d-flex flex-row" },
                            [
                              _c(
                                "div",
                                { staticClass: "d-flex flex-fill" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "second-btn",
                                      on: {
                                        click: function ($event) {
                                          return _vm.gotoAdvancedSearch()
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.advancedSearchText))]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "d-flex justify-content-end" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "first-btn",
                                      staticStyle: { border: "none" },
                                      attrs: { type: "submit" },
                                    },
                                    [_vm._v(_vm._s(_vm.okTitle))]
                                  ),
                                  _vm._v(" "),
                                  _vm.mode === 0
                                    ? _c(
                                        "b-button",
                                        {
                                          staticClass: "ml-2",
                                          staticStyle: { display: "none" },
                                          attrs: { type: "reset" },
                                        },
                                        [_vm._v(_vm._s(_vm.cancelTitle))]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._t("cancelButton"),
                                ],
                                2
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }